import React, { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import CanvasJSReact from '@canvasjs/react-charts';
import Navbar from '../components/home/Navbar';

const CanvasJS = CanvasJSReact.CanvasJS;
const CanvasJSChart = CanvasJSReact.CanvasJSChart;

const ViewStatGenre = () => {
  const [years, setYears] = useState([]);
  const [selectedYear, setSelectedYear] = useState(null);
  const [details, setDetails] = useState(null);

  useEffect(() => {
    const fetchYears = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'statistics_genre'));
        const yearsSet = new Set();
        querySnapshot.forEach((doc) => {
          yearsSet.add(doc.data().annee);
        });
        const sortedYears = Array.from(yearsSet).sort((a, b) => b - a);
        setYears(sortedYears);

        if (sortedYears.length > 0) {
          const defaultYear = sortedYears[0];
          setSelectedYear(defaultYear);
          await fetchYearData(defaultYear);
        }
      } catch (error) {
        console.error("Error fetching years: ", error);
      }
    };

    fetchYears();
  }, []);

  const fetchYearData = async (year) => {
    try {
      const querySnapshot = await getDocs(collection(db, 'statistics_genre'));
      const yearData = querySnapshot.docs
        .filter(doc => doc.data().annee === year)
        .map(doc => doc.data())[0];

      if (!yearData) {
        throw new Error('No data found for the selected year');
      }

      const numericData = {
        Hommes: Number(yearData.hommes),
        Femmes: Number(yearData.femmes),
      };

      console.log('Numeric Data:', numericData);
      setDetails(numericData);
    } catch (error) {
      console.error("Error fetching details: ", error);
    }
  };

  const handleYearClick = async (year) => {
    setSelectedYear(year);
    await fetchYearData(year);
  };

  const calculatePercentages = (data) => {
    if (!data) return [];

    const total = Object.values(data).reduce((sum, value) => sum + value, 0);
    console.log("Total:", total);

    if (total === 0) return [];

    return [
      { label: "Hommes", y: parseFloat((data.Hommes / total * 100).toFixed(3)), color: "#1f77b4" },
      { label: "Femmes", y: parseFloat((data.Femmes / total * 100).toFixed(3)), color: "#e377c2" }
    ];
  };

  const options = {
    animationEnabled: true,
    exportEnabled: true,
    theme: "light1",
    title: {
      text: ''
    },
    data: [{
      type: "pie",
      indexLabel: "{label}: {y}%",
      startAngle: -90,
      dataPoints: calculatePercentages(details),
    }]
  };

  const calculateTotal = (data) => {
    if (!data) return 0;
    return data.Hommes + data.Femmes;
  };

  return (
    <div>
      <Navbar />
      <div style={{ display: 'flex' }}>
        <div style={{
          width: '200px',
          borderRight: '1px solid #ddd',
          padding: '20px',
          backgroundColor: '#f9f9f9',
          height: '100vh',
          boxShadow: '2px 0 5px rgba(0,0,0,0.1)',
          borderRadius: '8px'
        }}>
          <h3 style={{
            fontFamily: 'Arial, sans-serif',
            fontSize: '18px',
            fontWeight: 'bold',
            color: '#317873',
            margin: '0 0 20px 0'
          }}>
            Années
          </h3>
          <ul style={{
            listStyleType: 'none',
            padding: 0,
            margin: 0
          }}>
            {years.map(year => (
              <li key={year}
                  onClick={() => handleYearClick(year)}
                  style={{
                    cursor: 'pointer',
                    padding: '10px',
                    borderRadius: '4px',
                    transition: 'background-color 0.3s ease',
                    marginBottom: '5px',
                    backgroundColor: '#ffffff',
                    color: '#0d47a1',
                    border: '1px solid #bbdefb'
                  }}
                  onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#bbdefb'}
                  onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#ffffff'}
              >
                {year}
              </li>
            ))}
          </ul>
        </div>
        <div style={{ flex: 1, padding: '10px' }}>
        <div style={{
            backgroundColor: '#00674b', // Background color for the title
            color: '#ffffff', // Text color
            padding: '20px', // Padding around the text
            borderRadius: '10px', // Rounded corners
            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)', // Subtle shadow
            marginBottom: '20px', // Space below the title
            textAlign: 'center'
          }}>
            <h2 style={{
              fontFamily: 'Chalkboard, Comic Sans MS, cursive, sans-serif',
              fontSize: '32px',
              fontWeight: 'bold',
              margin: 0
            }}>
              Statistiques par genre pour l'année {selectedYear || ''}
            </h2>
            </div>

{details ? (
  <>
    <CanvasJSChart options={options} />
    <p style={{
      textAlign: 'center',
      fontSize: '18px',
      fontWeight: 'bold',
      color: '#333',
      marginTop: '10px',
      padding: '10px',
      borderRadius: '5px',
      boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)'
    }}>
      Nombre total des personnes: <span style={{ color: '#317873' }}>{calculateTotal(details)}</span>
    </p>
  </>
) : (
  <p>Loading...</p>
)}
</div>
</div>
</div>
);
};

export default ViewStatGenre;
